import React from "react";
//#region redux
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AppState } from "store";
import { addIntroduction } from "store/actions/authActions";
//#endregion
//#region types
import { DialogEnums, StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { CommonConstants } from "utils/constants";
//#endregion
//#region components
import { DialogContainer } from "components/common";
import { useUserService } from "serviceHooks";
import MobileAppPromotionContent from "./content";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import HandMobileAppImg from "images/hand-mobileapp@2x.png";

const MobileAppPromotionPopup: React.FC = () => {
  const [showPromotion, setShowPromotion] = React.useState(false);
  const userService = useUserService();
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const alreadyShown = useSelector((state: AppState) =>
    state.auth.profileToggles.shownIntroductions?.includes(CommonConstants.MobileAppPromotionId)
  );

  const welcomeGuideIntroShown = useSelector((state: AppState) =>
    state.auth.profileToggles.shownIntroductions?.includes(CommonConstants.WelcomeGuideId)
  );

  const welcomeGuideHelpShown = useSelector((state: AppState) =>
    state.auth.profileToggles.shownHelps?.includes(CommonConstants.WelcomeGuideId)
  );

  const allowWintCardRegistration = useSelector(
    (state: AppState) => state.auth.selectedCompany.allowWintCardRegistration
  );

  React.useEffect(() => {
    if (alreadyShown) return;
    if (alreadyShown === undefined) return;
    if (!welcomeGuideIntroShown || !welcomeGuideHelpShown) return;
    if (allowWintCardRegistration) return;

    setShowPromotion(true);
  }, [alreadyShown, welcomeGuideIntroShown, welcomeGuideHelpShown, allowWintCardRegistration]);

  const onClose = () => {
    setShowPromotion(false);
    userService.markIntroductionAsShown(CommonConstants.MobileAppPromotionId);
    dispatch(addIntroduction(CommonConstants.MobileAppPromotionId));
  };

  return (
    <DialogContainer
      isOpen={showPromotion}
      dialogType={DialogEnums.DialogType.WalkingMan}
      type={StyleEnums.DisplayType.Info}
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.MobileAppPromotion.Title)}
      className={cssExports.mobileAppPromotionDialogRoot}
      customContent={<img src={HandMobileAppImg} alt="" className={cssExports.walkingMan} />}
      onClose={onClose}
    >
      <MobileAppPromotionContent onClose={onClose} />
    </DialogContainer>
  );
};

export default MobileAppPromotionPopup;
